import { cva } from '@/styled-system/css';

export const radioRecipe = cva({
  base: {
    'backgroundColor': 'bg.neutral',
    'display': 'inline-block',
    'cursor': 'pointer',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.thick} var(--shadow-color)',
      _notDisabled: {
        _focusVisible: 'inset 0 0 0 {borderWidths.thick} var(--shadow-color), {shadows.focus}',
      },
    },
    'borderRadius': 'shape.ellipse',
    'boxShadowColor': {
      base: 'border.action.neutral.default',
      _notDisabled: {
        _hover: 'Radio.border.hover',
        _active: 'Radio.border.pressed',
      },
    },
    'width': 'Radio.ring.width',
    'height': 'Radio.ring.height',
    'transitionProperty': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow',
    },
    'transitionDuration': {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    'transitionTimingFunction': '{easings.ease}',

    '&:checked': {
      boxShadow: {
        base: 'inset 0 0 0 {borderWidths.control.selected} var(--shadow-color)',
        _notDisabled: {
          _focusVisible:
            'inset 0 0 0 {borderWidths.control.selected} var(--shadow-color), {shadows.focus}',
        },
      },
      boxShadowColor: {
        base: 'border.action.hero.selected.default',
        _notDisabled: {
          _hover: 'border.action.hero.selected.hover',
          _active: 'border.action.hero.selected.pressed',
        },
      },
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
  },
});
